import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://api.mocki.io/v1/f5915043",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export default {
  getOrder() {
    return apiClient.get("");
  }
};
